export const config = {
  apiUrl: <string>process.env.API_URL,
  env: <'local' | 'dev' | 'prod'>process.env.ENV,
}
